import { Injectable } from '@angular/core';
import { ConfigService } from '../common/services/config.service';
import { HttpInterceptor } from '../common/services/httpInterceptor.service';
import { SessionHandlerService } from '../common/services/sessionHandler.service';
import { CommonConstants } from '../common/utilities/commonConstants';

@Injectable()
export class GetGoingCall {
    constructor(
        private _httpInterceptor: HttpInterceptor,
        private sessionHandlerService: SessionHandlerService
    ) { }
    public PostCallService(data) {
        /*
        JSON.parse() is used here to convert string value to boolean
        When we store values in session they get stored in string
        */
        data.payload.isSSO = JSON.parse(this.sessionHandlerService.GetSession(CommonConstants.CookieKeys.ssoEnabled) || 'false');
        const url = ConfigService.getInstance().getConfigObject().APIURL.postCall;
        return this._httpInterceptor.applicationTokensPost(url, data);
    }
    public GetCallService() {
        const url = ConfigService.getInstance().getConfigObject().APIURL.getCall;
        return this._httpInterceptor.Get(url);

    }

    public postSendMobileOTP(data) {
        data.notificationTypeCode = 'IMHLTHMOBILEOTP';
        const url = ConfigService.getInstance().getConfigObject().APIURL.resumeGetOtp;
        return this._httpInterceptor.Post(url, data);
    }

    public postValidateOTP(data) {
        const url = ConfigService.getInstance().getConfigObject().APIURL.ValidatePostOtp;
        return this._httpInterceptor.Post(url, data);
    }
}
